export const SUBDOMAIN_PATTERN = /^[a-z\d]+[-a-z\d]+[a-z\d]+$/
export const USERNAME_PATTERN = /^[^\s]+([^\s]+)*$/
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const PASSWORD_PATTERN = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/
export const NAME_PATTERN = /^[^\s]+(\s+[^\s]+)*$/
